import { Tag } from 'antd';
import { DataTableColumnHeader } from 'common/data-table-column-header';
import { dateTimeCell, linkCell } from 'utils/cell-formatter';
import { investmentIdentificationImageTypeLabels } from 'utils/constants';

export const columnsGenerator = ({ userId }: { userId?: string } = {}) => [
  {
    accessorKey: 'id',
    header: '',
    cell: ({ getValue }) =>
      linkCell({
        getValue,
        path: `/investment/users/${userId}/user-ekyc-records`,
      }),
  },
  {
    accessorKey: 'image_type',
    header: 'Type',
    cell: ({ getValue }) => {
      const value = getValue();
      return investmentIdentificationImageTypeLabels[value] || value;
    },
  },

  {
    accessorKey: 'kyc_action_type',
    header: 'Action type',
  },
  {
    accessorKey: 'kyc_message',
    header: 'Message',
  },
  {
    accessorKey: 'kyc_provider',
    header: 'Provider',
  },
  {
    accessorKey: 'kyc_status',
    header: 'Status',
  },
  {
    accessorKey: 'is_passed_criteria',
    header: 'Passed criteria',
    meta: {
      className: 'text-center',
    },
    cell: ({ getValue }) => {
      const value = getValue();
      return value ? (
        <Tag color="green">{'Đạt'}</Tag>
      ) : value === false ? (
        <Tag color="orange">{'Không đạt'}</Tag>
      ) : (
        value
      );
    },
  },
  {
    accessorKey: 'kyc_updated_at',
    header: ({ column }) => (
      <DataTableColumnHeader column={column} title="KYC Updated" />
    ),
    cell: dateTimeCell,
  },
  {
    accessorKey: 'updated_at',
    header: ({ column }) => (
      <DataTableColumnHeader column={column} title="Updated" />
    ),
    cell: dateTimeCell,
  },
  {
    accessorKey: 'created_at',
    header: ({ column }) => (
      <DataTableColumnHeader column={column} title="Created" />
    ),
    cell: dateTimeCell,
  },
];
